import { AppRouteProps } from '@harea/component'
import React from 'react'
import { GroupsCreateRoutes } from './groups/views/create/GroupsCreateRoutes';
import { GroupsDetailsRoutes } from './groups/views/details/GroupsDetailsRoutes';

const UserOrganisationDetailsAbout = React.lazy(
    () => import("./about/containers/UserOrganisationDetailsAbout")
);
const UserOrganisationDetailsParameters = React.lazy(
    () => import("./parameters/containers/UserOrganisationDetailsParameters")
);
const UserOrganisationRolesList = React.lazy(
    () => import("./roles/containers/UserOrganisationGroupsList")
);
const UserOrganisationGroupsList = React.lazy(
    () => import("./groups/containers/GroupsOrganisationList")
);
const UserOrganisationDepartmentsList = React.lazy(
    () => import("./departments/containers/UserOrganisationDepartmentsList")
);
const UserOrganisationInvitationList = React.lazy(
    () => import("./users/containers/UserOrganisationInvitationList")
);
const EmployeeOrganisationList = React.lazy(
    () => import("./employees/container/EmployeeOrganisationList")
);

export const UserOrganisationViewRoutes: Array<AppRouteProps> = [
    {
        path: "about",
        title: "Generic.UserOrganisation.About.title",
        element: <UserOrganisationDetailsAbout />,
    },
    {
        path: "roles",
        title: "Generic.UserOrganisation.Roles.title",
        element: <UserOrganisationRolesList />,
    },
    {
        path: "groups",
        title: "Generic.UserOrganisation.Groups.title",
        element: <UserOrganisationGroupsList />,
        children: [
            ...GroupsCreateRoutes
        ]
    },
    // ...GroupsDetailsRoutes,
    {
        path: "departments",
        title: "Generic.UserOrganisation.Departments.title",
        element: <UserOrganisationDepartmentsList />,
    },
    {
        path: "users",
        title: "Generic.UserOrganisation.Users.title",
        element: <UserOrganisationInvitationList />,
    },
    {
        path: "employees",
        title: "Generic.UserOrganisation.Employees.title",
        element: <EmployeeOrganisationList />,
    },
    {
        path: "parameters",
        title: "Generic.UserOrganisation.Parameters.title",
        element: <UserOrganisationDetailsParameters />,
    },
];
